module.exports = __webpack_public_path__ + "media/images/corefl-69e005820342741b839892da389a195b.jpg";